export default ({ request }) => ({
  ecomAmzListingSkuOutofstockListApi(data = {}) {
    return request({
      url: '/ecom/amz/listing/sku/outofstock/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzListingSkuOutofstockDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/listing/sku/outofstock/detail',
      method: 'POST',
      data,
    })
  },
})
